import { useState, useRef, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, TextButton, Popover, generateId } from 'bonfire-kindling';

import { useOpportunitiesActiveTab } from 'helpers/opportunities';
import { useFeatureFlags } from 'helpers/hooks';
import SavedSearchList from './SavedSearchList';

const OpportunitiesSavedSearch = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const { isFlagEnabled } = useFeatureFlags();
  const activeTab = useOpportunitiesActiveTab();

  const anchorId = useMemo(() => generateId(), []);
  const popoverId = useMemo(() => generateId(), []);

  if (!isFlagEnabled('FF_25_RELEASE_TOGGLE_PV_SAVED_SEARCH') || activeTab !== 'saved') {
    return null;
  }

  return (
    <Box sx={{ ml: 3, display: 'flex', alignItems: 'center', flex: '1 1 0%' }}>
      <TextButton
        id={anchorId}
        variant="outline"
        label={t('opportunities.filters.saved_search')}
        iconRight="caret-down"
        sx={{ mr: 3 }}
        ref={anchorRef}
        onClick={() => setOpen(true)}
        aria-expanded={open}
        aria-controls={popoverId}
        aria-haspopup="dialog"
      />
      <TextButton variant="contained" label={t('opportunities.filters.save_current_search')} />
      <Popover
        id={popoverId}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        elevation={4}
        onClose={() => setOpen(false)}
        open={open}
        role="dialog"
        aria-labelledby={anchorId}
        PaperProps={{ sx: { width: '20rem' } }}
      >
        <Box sx={{ p: 3 }}>
          <TextButton
            component={RouterLink}
            variant="contained"
            label={t('opportunities.filters.add_advanced_search')}
            to="/settings/saved"
            fullWidth
          />
        </Box>
        <SavedSearchList />
      </Popover>
    </Box>
  );
};

export default OpportunitiesSavedSearch;
